import store from './store';

export default {
    methods: {
        // 判断固定属性，不在DNA属性中
        // 不是dna属性，正常展示，如果成为dna属性，则不展示这个固定属性
        MixinJudgeFixedAttrNotInDna(fixedAttr) {
            return !(store.fixedAttrs || []).includes(fixedAttr);
        },
        MixinGetDnaExtAttrIds() {
            return store.extAttrs || [];
        },
    },
};
